import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { MainRoutes } from 'helpers/routes';
import useUser from 'hooks/useUser';
import { appRoles } from 'utils/enums';

import { activeStyle, Menu, MenuItem } from 'components/templates/menus/styles';

const AdminVerificationMenu = () => {
  const { pathname } = useLocation();
  const { roleName } = useUser();

  return (
    <Menu>
      <MenuItem
        as={NavLink}
        to={MainRoutes.VERIFICATION}
        style={({ isActive }) => (isActive && !pathname.includes('surveys') ? activeStyle : undefined)}
      >
        In Verification
      </MenuItem>
      {roleName !== appRoles.abaADMIN && (
        <MenuItem
          as={NavLink}
          to={`${MainRoutes.VERIFICATION}/surveys`}
          style={({ isActive }) => (isActive ? activeStyle : undefined)}
        >
          Survey Management
        </MenuItem>
      )}
    </Menu>
  );
};

export default AdminVerificationMenu;
